import React from "react"
import styled, { CSSProperties } from 'styled-components';

const StyledStack = styled.div<any>`
  display: flex;
  flex-direction: ${props => props.horizontal ? 'row' : 'column'};
  justify-content: ${props => props.horizontalAlign ? props.horizontalAlign : 'flex-start'};
  ${props => typeof props.flexGrow === 'undefined' ? '' : 'flex-grow: ' + props.flexGrow};
  gap: ${props => props.gap ? props.gap : 0}px;
  flex: 1;
	${props => typeof props.$wrap === 'undefined' ? '' : 'flex-wrap: ' + (props.$wrap ? 'wrap' : 'nowrap')}
  ${props => typeof props.userSelect === 'undefined' ? '' : 'user-select: ' + props.userSelect};
`;

type StackProps = {
  // style?: {
  //   padding?: string | number;
  //   display?: string;
  //   flexGrow?: number;
  //   flexShrink?: number;
  //   userSelect?: string;
  // }
  style?: CSSProperties;
  horizontal?: boolean;
  horizontalAlign?: 'flex-start' | 'center' | 'flex-end' | 'space-between' | 'space-around' | 'space-evenly',
  $wrap?: boolean;
  gap?: number;
  onClick?: Function;
}


export const Stack = (props: React.PropsWithChildren<StackProps>) => {
  return (
    <StyledStack {...props} />
  )
}